import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const NOTAS_EVALUATIVAS_CONST = 'notas-evaluativas';
export const notasEvaluativasApi = `${baseUrl}/${NOTAS_EVALUATIVAS_CONST}`;

export const saveNotasEvaluativasService = async (id, data) => {
  let res;
  if (!id) {
    res = await axios.post(notasEvaluativasApi, data, {
      headers: token({}),
    });
  } else {
    res = await axios.patch(`${notasEvaluativasApi}/${id}`, data, {
      headers: token({}),
    });
  }
  return res;
};
